module.exports = __webpack_public_path__ + "static/briscoe-5e662c49f96dcf62d7b757160f99d32b.jpg";